import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import TopNavigation from "../../components/TopNavigation";
import BaseLayout from "../../components/BaseLayout";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import "./style.scss";
import { Row, Col } from "react-bootstrap";
import PointSummary from "./pointSummary";
import StarSummary from "./starSummary";
import { dateFormater } from "../../utils/utilities";
import Tabs from "../../components/Tabs";
import { PointStart } from "../../utils/constant";

const HeaderContent = ({ name, lastInfo }) => (
  <div className="content-header">
    <TopNavigation
      titlePage=""
      toPath={PageRoutes.home}
      setBorder={false}
      showLeftIcon={false}
      showRightIcon={false}
      iconLeft={Assets.iconBackWhite}
      iconRight={Assets.iconSetting}
      rightEvent={true}
      rightEventPath={PageRoutes.setting}
    />
    <Row className="home-account-section">
      <Col xs={9} sm={9} md={9} className="account-info">
        <div className="account-name">{name}</div>
        {/* <div>{lastInfo}</div> */}
      </Col>
    </Row>
  </div>
);

const IndexPointSummary = (props) => {
  const {
    pointSummaryData,
    starSummaryData,
    pointInfo,
    starInfo,
    initHome,
    profile,
    pwa_setting,
  } = props;

  const [activeTabs, setActiveTabs] = useState(
    profile.organization_settings.activate_points === 1 ? 1 : 2
  );

  useEffect(() => {
    initHome();
  }, []);

  const onChangeTabs = (tabActive) => {
    setActiveTabs(tabActive);
  };

  return (
    <div className="home-page">
      <BaseLayout
        show_menu={pwa_setting.show_main_menu}
        bottomNavIndex={0}
        header={
          <HeaderContent
            name={`${profile.user_details.first_name} ${profile.user_details.last_name}`}
            lastInfo={`Last point activity ${dateFormater(
              pointSummaryData.today
            )}`}
          />
        }
      >
        <div className="home-content">
          <div className="d-flex wrapper-tab align-items-center">
            {PointStart.map((cat, index) => (
              <Tabs
                id={cat.id}
                key={index}
                name={cat.name}
                isActive={activeTabs}
                onClick={() => onChangeTabs(cat.id, cat.name)}
              />
            ))}
          </div>
          {activeTabs === 1 && (
            <PointSummary
              pointSummaryData={pointSummaryData}
              pointInfo={pointInfo}
              expiredDate={profile.user_details.point_expiry_date}
            />
          )}
          {activeTabs === 2 && (
            <Row className="home-star-content">
              <StarSummary
                starSummaryData={starSummaryData}
                starInfo={starInfo}
              />
            </Row>
          )}
          {activeTabs === "badge" && (
            <Row className="home-badge-content">Badge Page</Row>
          )}
        </div>
      </BaseLayout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  pointSummaryData: state.FinanceSM.pointSummaryData,
  starSummaryData: state.FinanceSM.starSummaryData,
  profile: state.LoginSM.login,
  pwa_setting: state.LoginSM.login.organization_pwa_settings,
});

const mapDispatchToProps = (dispatch) => ({
  initHome: dispatch.FinanceSM.initHome,
});

export default connect(mapStateToProps, mapDispatchToProps)(IndexPointSummary);
